﻿{
  "createAccount": "Luo tili",
  "subscription": "Tilaus",
  "oneTimePurchase": "Kertaluontoinen hankinta",
  "billingDetails": "Laskutustiedot",
  "paymentDetails": "Maksutiedot",
  "requestAQuote": "Organisaation pyyntölomake",
  "reviewOrder": "Tarkasta tilaus",
  "thankYouForYourOrder": "Kiitos tilauksestasi!",
  "joinTheCommunity": "Liity yhteisöön",
  "startTrial": "Aloita koekäyttö",
  "yourTrialHasEnded": "Kokeilujaksosi on päättynyt",
  "taxExempt": "Verovapaus",
  "taxExemptThankYou": "Päivitys onnistui!",
  "planDetails": "Tilaukseni tiedot",
  "modifyPlan": "Muuta suunnitelmaa",
  "modifyPaymentDetails": "Muuta laskutustietoja",
  "redirect": "Uudelleen suuntaaminen Boardmakeriin",
  "perpetualTrial": "Lataa {{trialLength}} päivän maksuton kokeilu",
  "perpetualThankYou": "Ohjelmistosi on valmis!",
  "downloads": "Lataa Boardmaker",
  "partner": "Paikanna kumppani",
  "intro": "Valitse alla oleva Boardmaker-tuote ladataksesi uusimman version laitteellesi.",
"systemRequirements": "Järjestelmävaatimukset",
"releaseNotes": "Julkaisutiedot",
"comparison": "Vertaile tilausta ja lisenssiä"
}
